export default __webpack_public_path__ + "static/media/secondStep.28c79bc6.jpg";